import {
  TREQUEST_ADD_NEW_WORKSTATION,
  TREQUEST_ASSIGN_MACHINE_TO_WORKSTATION,
  TREQUEST_REMOVE_MACHINE_FROM_WORKSTATION,
  TREQUEST_REMOVE_WORKSTATION,
  TREQUEST_REPLACE_MACHINE_FROM_WORKSTATION,
  TREQUEST_RESET_FACTORY_PRODUCTION_AREA,
  TRESPONSE_GET_ALL_SHIFT_SCHEDULE_LINE_LOCATIONS,
  TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA,
  TRESPONSE_GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST,
  TRESPONSE_LOCATION_LIST,
  TREQUEST_ADD_MACHINE_NEEDLES,
  TREQUEST_REMOVE_MACHINE_NEEDLES,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import {
  TLineSetupActionsAssignMachineFetchPayload,
  TLineSetupActionsRemoveMachineFetchPayload,
  TLineSetupActionsEditWorkstationFetchPayload,
  TLineSetupActionsReplaceMachineFetchPayload,
  TLineSetUpActionType,
} from './line-setup.models';

export class GetFactoryLineWorkstationSummaryList implements Action {
  readonly type = TLineSetUpActionType.GetFactoryLineWorkstationSummaryList;
}

export class GetFactoryLineWorkstationSummaryListSuccess implements Action {
  readonly type = TLineSetUpActionType.GetFactoryLineWorkstationSummaryListSuccess;
  constructor(public res: TRESPONSE_GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST) {}
}

export class GetFactoryLineWorkstationSummaryListFailure implements Action {
  readonly type = TLineSetUpActionType.GetFactoryLineWorkstationSummaryListFailure;
}

export class AddNewWorkstation implements Action {
  readonly type = TLineSetUpActionType.AddNewWorkstation;
  constructor(
    public payload: Omit<TREQUEST_ADD_NEW_WORKSTATION, 'factoryId'>,
    public fetchPayload: TLineSetupActionsEditWorkstationFetchPayload,
  ) {}
}

export class AddNewWorkstationSuccess implements Action {
  readonly type = TLineSetUpActionType.AddNewWorkstationSuccess;
}

export class AddNewWorkstationFailure implements Action {
  readonly type = TLineSetUpActionType.AddNewWorkstationFailure;
}

export class GetAllWorkstationsForProductionArea implements Action {
  readonly type = TLineSetUpActionType.GetAllWorkstationsForProductionArea;
  constructor(public locationId: TRESPONSE_LOCATION_LIST['locationDetails'][number]['id']) {}
}

export class GetAllWorkstationsForProductionAreaSuccess implements Action {
  readonly type = TLineSetUpActionType.GetAllWorkstationsForProductionAreaSuccess;
  constructor(public res: TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA) {}
}

export class GetAllWorkstationsForProductionAreaFailure implements Action {
  readonly type = TLineSetUpActionType.GetAllWorkstationsForProductionAreaFailure;
}

export class AssignMachineToWorkstation implements Action {
  readonly type = TLineSetUpActionType.AssignMachineToWorkstation;
  constructor(
    public payload: Omit<TREQUEST_ASSIGN_MACHINE_TO_WORKSTATION, 'factoryId'>,
    public fetchPayload: TLineSetupActionsAssignMachineFetchPayload,
  ) {}
}

export class AssignMachineToWorkstationSuccess implements Action {
  readonly type = TLineSetUpActionType.AssignMachineToWorkstationSuccess;
}

export class AssignMachineToWorkstationFailure implements Action {
  readonly type = TLineSetUpActionType.AssignMachineToWorkstationFailure;
}

export class RemoveMachineFromWorkstation implements Action {
  readonly type = TLineSetUpActionType.RemoveMachineFromWorkstation;
  constructor(
    public payload: Omit<TREQUEST_REMOVE_MACHINE_FROM_WORKSTATION, 'factoryId'>,
    public fetchPayload: TLineSetupActionsRemoveMachineFetchPayload,
  ) {}
}

export class RemoveMachineFromWorkstationSuccess implements Action {
  readonly type = TLineSetUpActionType.RemoveMachineFromWorkstationSuccess;
}

export class RemoveMachineFromWorkstationFailure implements Action {
  readonly type = TLineSetUpActionType.RemoveMachineFromWorkstationFailure;
}

export class ReplaceMachine implements Action {
  readonly type = TLineSetUpActionType.ReplaceMachine;
  constructor(
    public payload: Omit<TREQUEST_REPLACE_MACHINE_FROM_WORKSTATION, 'factoryId'>,
    public fetchPayload: TLineSetupActionsReplaceMachineFetchPayload,
  ) {}
}

export class ReplaceMachineSuccess implements Action {
  readonly type = TLineSetUpActionType.ReplaceMachineSuccess;
}

export class ReplaceMachineFailure implements Action {
  readonly type = TLineSetUpActionType.ReplaceMachineFailure;
}

export class RemoveWorkstation implements Action {
  readonly type = TLineSetUpActionType.RemoveWorkstation;
  constructor(
    public payload: Omit<TREQUEST_REMOVE_WORKSTATION, 'factoryId'>,
    public fetchPayload: TLineSetupActionsEditWorkstationFetchPayload,
  ) {}
}

export class RemoveWorkstationSuccess implements Action {
  readonly type = TLineSetUpActionType.RemoveWorkstationSuccess;
}

export class RemoveWorkstationFailure implements Action {
  readonly type = TLineSetUpActionType.RemoveWorkstationFailure;
}

export class ResetFactoryProductionArea implements Action {
  readonly type = TLineSetUpActionType.ResetFactoryProductionArea;
  constructor(public payload: Omit<TREQUEST_RESET_FACTORY_PRODUCTION_AREA, 'factoryId'>) {}
}

export class ResetFactoryProductionAreaSuccess implements Action {
  readonly type = TLineSetUpActionType.ResetFactoryProductionAreaSuccess;
}

export class ResetFactoryProductionAreaFailure implements Action {
  readonly type = TLineSetUpActionType.ResetFactoryProductionAreaFailure;
}

export class GetFactoryLinesForShiftManagement implements Action {
  readonly type = TLineSetUpActionType.GetFactoryLinesForShiftManagement;
}

export class GetFactoryLinesForShiftManagementSuccess implements Action {
  readonly type = TLineSetUpActionType.GetFactoryLinesForShiftManagementSuccess;
  constructor(public res: TRESPONSE_GET_ALL_SHIFT_SCHEDULE_LINE_LOCATIONS) {}
}

export class GetFactoryLinesForShiftManagementFailure implements Action {
  readonly type = TLineSetUpActionType.GetFactoryLinesForShiftManagementFailure;
}

export class AddMachineNeedles implements Action {
  readonly type = TLineSetUpActionType.AddMachineNeedles;
  constructor(public payload: TREQUEST_ADD_MACHINE_NEEDLES) {}
}

export class AddMachineNeedlesSuccess implements Action {
  readonly type = TLineSetUpActionType.AddMachineNeedlesSuccess;
}

export class AddMachineNeedlesFailure implements Action {
  readonly type = TLineSetUpActionType.AddMachineNeedlesFailure;
}

export class RemoveMachineNeedles implements Action {
  readonly type = TLineSetUpActionType.RemoveMachineNeedles;
  constructor(public payload: TREQUEST_REMOVE_MACHINE_NEEDLES) {}
}

export class RemoveMachineNeedlesSuccess implements Action {
  readonly type = TLineSetUpActionType.RemoveMachineNeedlesSuccess;
}

export class RemoveMachineNeedlesFailure implements Action {
  readonly type = TLineSetUpActionType.RemoveMachineNeedlesFailure;
}

export type TLineSetupActions =
  | GetFactoryLineWorkstationSummaryList
  | GetFactoryLineWorkstationSummaryListSuccess
  | GetFactoryLineWorkstationSummaryListFailure
  | AddNewWorkstation
  | AddNewWorkstationSuccess
  | AddNewWorkstationFailure
  | GetAllWorkstationsForProductionArea
  | GetAllWorkstationsForProductionAreaSuccess
  | GetAllWorkstationsForProductionAreaFailure
  | AssignMachineToWorkstation
  | AssignMachineToWorkstationSuccess
  | AssignMachineToWorkstationFailure
  | ReplaceMachine
  | ReplaceMachineSuccess
  | ReplaceMachineFailure
  | RemoveMachineFromWorkstation
  | RemoveMachineFromWorkstationSuccess
  | RemoveMachineFromWorkstationFailure
  | RemoveWorkstation
  | RemoveWorkstationSuccess
  | RemoveWorkstationFailure
  | ResetFactoryProductionArea
  | ResetFactoryProductionAreaSuccess
  | ResetFactoryProductionAreaFailure
  | GetFactoryLinesForShiftManagement
  | GetFactoryLinesForShiftManagementSuccess
  | GetFactoryLinesForShiftManagementFailure
  | AddMachineNeedles
  | AddMachineNeedlesSuccess
  | AddMachineNeedlesFailure
  | RemoveMachineNeedles
  | RemoveMachineNeedlesSuccess
  | RemoveMachineNeedlesFailure;
